var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudModal',{attrs:{"title":_vm.$t('modals.company.billwerkChangeTitle'),"action":"update","on-submit":_vm.submitContractChange,"on-close":() => _vm.$emit('close'),"error-message":_vm.errorMessage}},[_c('BillwerkOrder',{attrs:{"order-data":_vm.orderData,"change":"","bookable-sales-plans":[]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }